<template>
  <div>
    <table class="table table-striped" style="border-bottom: 1px solid #dee2e6">
      <tbody>
        <tr>
          <td>Status</td>
          <td class="font-medium">
            <b-badge variant="danger">
              {{ maintenanceDetailData.status }}
            </b-badge>
          </td>
        </tr>

        <tr>
          <td>Plan Maintenance</td>
          <td class="font-medium">
            {{ formatDate(maintenanceDetailData.lastMaintenanceDate) || '-' }}
          </td>
        </tr>

        <tr>
          <td>Actual Maintenance</td>
          <td class="font-medium">
            {{ maintenanceDetailData.actualMaintenanceDate || '-' }}
          </td>
        </tr>

        <tr>
          <td>Plan Maintenance (RH)</td>
          <td class="font-medium">
            {{ maintenanceDetailData.planMaintenanceRH ?? '-' }} Hours
          </td>
        </tr>
        <tr>
          <td>Actual Maintenance (RH)</td>
          <td class="font-medium">
            {{ maintenanceDetailData.actualMaintenanceRH ?? '-' }} Hours
          </td>
        </tr>
        <tr>
          <td>Cost</td>
          <td class="font-medium">
            Rp. {{ maintenanceDetailData.cost?.toLocaleString() ?? '-' }}
          </td>
        </tr>
        <tr>
          <td>Attachment</td>
          <td class="font-medium">
            <ul
              class="profile-img-gallary d-flex flex-wrap p-0 m-0"
              v-if="maintenanceDetailData.file"
            >
              <li
                class="col-md-1 col-1 pb-1"
                @click="
                  $emit('handleOpenFilePreview', maintenanceDetailData.file)
                "
              >
                <img
                  src="../../../../assets/images/activity/pdf.png"
                  alt="gallary-image"
                  class="img-fluid"
                />
              </li>
            </ul>
            <span class="text-muted" v-else>No File Exist..</span>
          </td>
        </tr>

        <tr>
          <td>Notes</td>
          <td class="font-medium">
            <p v-html="maintenanceDetailData.notes">
              {{ maintenanceDetailData.notes || '-' }}
            </p>
          </td>
        </tr>
        <template v-if="maintenanceDetailData?.postpone?.length">
          <tr v-if="maintenanceDetailData.trigger == 'CALENDAR'">
            <td>Postponed Date</td>
            <td class="font-medium">
              {{
                formatDate(maintenanceDetailData?.postpone?.[0].extraDate) ||
                '-'
              }}
            </td>
          </tr>
          <tr v-else>
            <td>Postponed (RH)</td>
            <td class="font-medium">
              {{ maintenanceDetailData?.postpone?.[0].extraHours ?? '-' }} Hours
            </td>
          </tr>
          <tr>
            <td>Postponed Notes</td>
            <td class="font-medium">
              <p v-html="maintenanceDetailData?.postpone?.[0].notes"></p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MaintenanceInfoList',
  props: {
    maintenanceDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date, 'DD-MM-YYYY').format('DD/MM/YYYY') : '-'
    },
  },
}
</script>

<style scoped>
.font-medium {
  font-weight: 500;
  width: 60%;
}
</style>
